module.exports = __webpack_public_path__ + "static/media/Gender_Donut.c9bf92d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Gender_Donut.svg
// module id = 362
// module chunks = 0